<template>
  <div class="choose_date lg:hidden">
    <div class="lg:hidden md:px-20 flex justify-center w-screen px-8 py-2 bg-white">
      <div
        class="md:flex-row md:justify-between flex flex-col items-center justify-center w-full max-w-screen-md"
      >
        <RmBtn
          color="blue"
          class="w-full h-12 rounded-full font-bold"
          @click="handleAddressSelect"
        >
          Заказать ёлочку
        </RmBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import RmBtn from '~/components/shared/rm_btn.vue'
import { useElka } from '~/composables/useElka'
import { useLot } from '~/composables/useLot'
import { useScrollTo } from '~/composables/useScrollTo'

export default {
  components: {
    RmBtn,
  },
  props: {
    lotId: {
      type: [String, Number],
      default: 0,
    },
  },
  setup (props) {
    const { scrollTo } = useScrollTo()
    const { lot } = useLot(props.lotId)
    const { range, handleSelectDate, handleAddressSelect, handleGetOrder } = useElka(props.lotId)

    return {
      lot,
      range,
      scrollTo,
      isAddressSelected: computed(() => useOrder().elka.value?.isAddressSelected),
      handleSelectDate: () => handleSelectDate(lot.value, lot.value.minRentDays),
      handleAddressSelect,
      handleGetOrder,
    }
  },
}
</script>

<style lang="sass" scoped>
  .choose_date
    @apply fixed z-20 bottom-0 left-0
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15)
</style>
